export default class FlatpickrConfigVuePlugin {
  static install (Vue) {
    Vue.mixin({
      created () {
        this.fpOptions = {
          altFormat: this.dateFormat,
          altInput: true,
          allowInput: true
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/ui/FlatpickrConfigVuePlugin.js